import cn from "classnames";
import {
  LOADER_DOTS,
  LOADER_SIZES,
  LOADER_TYPE,
  SPINNER_COLOR,
} from "./constants";
import { LoaderProps } from "./types";
import styles from "./styles.module.scss";

export const Loader = ({
  size = LOADER_SIZES.MEDIUM,
  type = LOADER_TYPE.DOT,
  color = SPINNER_COLOR.GREEN,
  className,
  dataTestId = "loader",
}: LoaderProps) => {
  switch (type) {
    case LOADER_TYPE.DOT:
      return (
        <div
          className={cn(styles.loader, className)}
          data-test-id={dataTestId}
          role="alert"
          aria-label="Загрузка"
        >
          {LOADER_DOTS.map((_, index) => (
            <span
              key={index}
              className={cn(styles.dot, styles[size])}
              data-test-id={`${dataTestId}-${type}`}
            />
          ))}
        </div>
      );

    case LOADER_TYPE.SPINNER:
      return (
        <div
          className={cn(styles.loader, className)}
          data-test-id={dataTestId}
          role="alert"
          aria-label="Загрузка"
        >
          <span
            className={cn(styles.spinner, styles[size], styles[color])}
            data-test-id={`${dataTestId}-${type}`}
          />
        </div>
      );

    default: {
      return null;
    }
  }
};
